// extracted by mini-css-extract-plugin
export default {"copyright":"style_copyright__Mg+Am","container":"style_container__Wd7tP"};